export default "__VITE_ASSET__DBiVBhd5__"